import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Layout from "@/components/Layout";
import ComingSoon from "@/pages/ComingSoon";
import Home from "@/pages/Home";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Campaigns from "@/pages/Campaigns";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import AboutUs from "@/pages/legal/AboutUs";
import UsagePolicy from "@/pages/legal/UsagePolicy";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import KVKK from "@/pages/legal/KVKK";
import SafeInternet from "@/pages/legal/SafeInternet";
import ManagementPolicy from "@/pages/legal/ManagementPolicy";
import { AdminAuthProvider } from "@/admin/AuthContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import ContentManager from "@/admin/ContentManager";
import Messages from "@/admin/Messages";
import AdminSettings from "@/admin/AdminSettings";

function App() {
  return (
    <LanguageProvider>
      <AdminAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/anasayfa" element={<Home />} />
              <Route path="/tarifeler" element={<Packages />} />
              <Route path="/tarifeler/:id" element={<PackageDetail />} />
              <Route path="/hizmetler" element={<Services />} />
              <Route path="/kurumsal" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/kampanyalar" element={<Campaigns />} />
              <Route path="/sss" element={<FAQ />} />
              <Route path="/iletisim" element={<Contact />} />
              <Route path="/hakkimizda" element={<AboutUs />} />
              <Route path="/kullanim-politikasi" element={<UsagePolicy />} />
              <Route path="/gizlilik-politikasi" element={<PrivacyPolicy />} />
              <Route path="/kvkk" element={<KVKK />} />
              <Route path="/guvenli-internet" element={<SafeInternet />} />
              <Route path="/yonetim-sistemleri-politikasi" element={<ManagementPolicy />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="content/:coll" element={<ContentManager />} />
              <Route path="messages" element={<Messages />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AdminAuthProvider>
    </LanguageProvider>
  );
}

export default App;
